import { c as _c } from "react/compiler-runtime";
import { CalendarDate } from '@newfront-insurance/string-formatters';
import type { JSX } from 'react';
import CalendarHeader from './components/header';
import CalendarMonth from './components/month';
import { useCalendar } from './hooks/calendar';
interface Props {
  onChange: (date?: CalendarDate) => unknown;
  value?: CalendarDate;
  validate?: (date: CalendarDate) => boolean;
  maxDate?: CalendarDate;
  minDate?: CalendarDate;
}
export function CalendarDatePicker(props) {
  const $ = _c(23);
  const {
    onChange,
    value,
    validate,
    maxDate,
    minDate
  } = props;
  let t0;
  if ($[0] !== maxDate) {
    t0 = maxDate?.getYear();
    $[0] = maxDate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const maxYear = t0;
  let t1;
  if ($[2] !== minDate) {
    t1 = minDate?.getYear();
    $[2] = minDate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const minYear = t1;
  let t2;
  let t3;
  let t4;
  if ($[4] !== value) {
    const today = CalendarDate.today();
    t4 = useCalendar;
    t2 = value ? value.getMonth() : today.getMonth();
    t3 = value ? value.getYear() : today.getYear();
    $[4] = value;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3) {
    t5 = {
      initialVisibleMonth: t2,
      initialVisibleYear: t3
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const calendar = t4(t5);
  let t6;
  if ($[11] !== calendar || $[12] !== maxYear || $[13] !== minYear) {
    t6 = <div className="pb-2"><CalendarHeader calendarHook={calendar} minYear={minYear} maxYear={maxYear} /></div>;
    $[11] = calendar;
    $[12] = maxYear;
    $[13] = minYear;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== calendar || $[16] !== onChange || $[17] !== validate || $[18] !== value) {
    t7 = <CalendarMonth calendarHook={calendar} onClick={onChange} validate={validate} selectedDate={value} />;
    $[15] = calendar;
    $[16] = onChange;
    $[17] = validate;
    $[18] = value;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <div className="w-[224px]">{t6}{t7}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}